export default __webpack_public_path__ + "static/media/analytics_death.631b448f.svg";